import React from 'react';
import HistorySetRow from 'react/matchHistoryPopup/HistorySetRow';

const firstPlayer = (match) => match.player1 || match.getTeams()[1].players[0];

// A list of sets as HistorySetRows, from the player's side. headToHead leaves
// the opponent out of every row, for lists against one player. With onSelect
// each row is a button to pick a set by, the one with selectedId pressed.
// Without a player, each set is read from its first player's side and names them.
export default function HistorySetList({ matches, player = null, headToHead = false, onSelect = null, selectedId = null }) {
	if(onSelect) {
		return (
			<div className='history-popup__sets'>
				{matches.map((match) => (
					<HistorySetRow key={match.id} match={match} player={player} headToHead={headToHead}
						onSelect={onSelect} selected={match.id === selectedId} />
				))}
			</div>
		);
	}
	return (
		<ul className='history-popup__sets'>
			{matches.map((match) => (
				<HistorySetRow key={match.id} match={match} player={player || firstPlayer(match)} headToHead={headToHead} showPlayer={!player} />
			))}
		</ul>
	);
}
